import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';

@Component({
  selector: 'app-download-group-profile',
  templateUrl: './download-group-profile.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class DownloadGroupProfileComponent {
  private rbs = inject(RightBridgeApiService);

  @Output() toggleLoading = new EventEmitter();
  @Input() applications;

  groupProfile = {
    id: null,
    app: null,
    group: null,
    save: false,
    status: null,
    statusClass: null,
  };

  getGroupProfile() {
    this.toggleLoading.emit();
    this.groupProfile.status = null;
    this.groupProfile.statusClass = null;
    this.rbs
      .downloadGroupProfile(
        this.groupProfile.id,
        this.groupProfile.app,
        this.groupProfile.group,
        this.groupProfile.save
      )
      .subscribe({
        next: async res => {
          this.toggleLoading.emit();
          const blobString = await res.text();
          if (blobString.includes('not found')) {
            const message = JSON.parse(blobString).group;
            this.groupProfile.status = message;
            this.groupProfile.statusClass = 'failure';
          } else {
            let fileData;
            const filename = `${this.groupProfile.app}-${this.groupProfile.group}-${this.groupProfile.id}.json`;
            const reader = new FileReader();
            reader.readAsDataURL(res);

            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename);
            };
          }
        },
        error: catchError(err => {
          this.toggleLoading.emit();
          this.groupProfile.status = err;
          this.groupProfile.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        }),
      });
  }
}
